import {
    AppBar,
    Box,
    Button,
    Card,
    CardHeader,
    Drawer,
    Grid,
    IconButton,
    List,
    ListItem,
    makeStyles,
    Paper,
    Theme,
    Toolbar,
    Typography,
} from '@material-ui/core';
import React, {
    useState,
    useEffect,
    useRef,
    useCallback,
    useImperativeHandle,
    forwardRef,
    ForwardRefRenderFunction,
    Dispatch,
    SetStateAction,
    Fragment,
} from 'react';
import {
    member as v_member,
    basic,
    Values,
    material,
    order as v_order,
    SNACKBAR_TIME,
} from '../request/values';
import { Waypoint } from 'react-waypoint';

import NumberFormat from 'react-number-format';

import clsx from 'clsx';

import { COLORS } from './Theme';

// Icon

import Dialog, { DialogConfirm } from './Dialog';
import { useSnackbar } from 'notistack';
import axios from 'axios';
import { SIcon } from './Icon';
import { useHistory } from 'react-router-dom';
import ToastStr from '../request/toastStr';
import TitleBar from './header/TitleBar';

const SERVER = basic.server;

const useStyles = makeStyles((theme: Theme) => ({
    wrapper: {
        paddingTop: '0',
        paddingLeft: '0',
        paddingRight: '0',
        [theme.breakpoints.up('md')]: {
            paddingTop: '10px',
            paddingLeft: '20px',
            paddingRight: '20px',
        },
    },
    container: {
        padding: 0,
        display: 'grid',
    },
    titleWrapper: {
        width: '100%',
        textAlign: 'center',
    },
    title: {
        ...theme.typography.h1,
        color: `${COLORS.BROWNISH_GREY}`,
        textAlign: 'center',
        [theme.breakpoints.up('md')]: {
            ...theme.typography.h4,
        },
    },
    materialItem: {
        borderRadius: 12,
        margin: 'auto',
        marginBottom: '1.5vh',

        boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
        width: '82vw',
        paddingTop: '2.2vh',
        paddingBottom: '2.2vh',
        [theme.breakpoints.up('md')]: {
            width: '60vw',
        },
    },
    itemProcessing: {
        backgroundColor: `${COLORS.LIGHT_GREY}`,
    },
    buttonWrapper: {
        textAlign: 'right',
        marginLeft: 'auto',
        paddingBottom: '1vh',
        paddingRight: '6vw',
        [theme.breakpoints.up('md')]: {
            paddingRight: '0',
        },
    },
    list: {
        width: '95vw',
        height: '70vh',
        overflowY: 'auto',
        ...theme.typography.subtitle1,
        fontFamily: 'NanumB',
        fontWeight: 'bold',
        [theme.breakpoints.up('md')]: {
            width: '62vw',
            height: '100%',
            paddingTop: theme.spacing(1),
            paddingBottom: theme.spacing(6),
        },
    },
    grid: {
        maxHeight: '80vh',
        overflowY: 'auto',
    },
    paper: {
        padding: theme.spacing(1),
        // margin: 'auto'
    },
    materialImage: {
        // height: 60,
        // width: 60
        textAlign: 'center',
        margin: 'auto',
        '& img': {
            width: '11vw',
            maxWidth: '70px',
        },
    },
    materialList: {
        width: '90%',
        maxWidth: 360,
    },
    materialCompanyName: {
        ...theme.typography.body1,
        fontWeight: 'bold',
        fontFamily: 'NanumB',
        color: `${COLORS.WATER_BLUE}`,
    },
    orderSheet: {
        // height : 'calc(100%- 64px)',
        // top: 64
        height: '100vh',
    },
    empty: {
        height: '62vh',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '& img': {
            width: '35vw',
            height: '35vw',
            [theme.breakpoints.up('md')]: {
                width: '25vw',
                height: '25vw',
            },
            marginBottom: '2.5vh',
            opacity: 0.4,
        },
        '& h1': {
            color: `${COLORS.DOWN}`,
        },
    },
    button: {
        height: 'auto',
        borderRadius: '5px',
        backgroundColor: `${COLORS.WATER_BLUE}`,
        color: `${COLORS.WHITE}`,
        boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
        padding: '1vw',
        ...theme.typography.body1,
        fontFamily: 'NanumB',
        //fontWeight: 'bold',
        width: 'auto',
    },
    bottonTitle: {
        color: `${COLORS.BROWNISH_GREY}`,
        ...theme.typography.subtitle2,
        fontFamily: 'NanumB',
        fontWeight: 'bold',
    },
    numberWrapper: {
        textAlign: 'right',
        [theme.breakpoints.up('md')]: {
            margin: 'auto',
        },
    },
    numberText: {
        ...theme.typography.h1,
        color: `${COLORS.BROWNISH_GREY}`,
        fontWeight: 'normal',
        fontFamily: 'NanumR',
        [theme.breakpoints.up('md')]: {
            ...theme.typography.h4,
        },
    },
}));

interface iMaterialList {
    materialCode: number;
    materialName: string;
    materialSubName: string;
    materialImage: string;
    materialPrice: number;
    quantity: number;
    companyName: string;
    companyNum: number;
    materialOrderNum: number;
    orderCompanyNum: number;
    totalPrice: number;
    orderCompanyName: string;
}

export interface refHandle {
    refreshCartList: () => void;
    handleOpen: () => void;
}

export interface InputProps {
    oper: any;
}

const MaterialSale: React.FC<any> = (props) => {
    const classes = useStyles();

    const [material, setMaterial] = useState<iMaterialList[]>([]);
    const [dialog, setDialog] = useState<number>(-1); // -1 = false, 0 > index
    const [orderState, setOrderState] = useState<boolean>(false);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const history = useHistory();

    const count = 20;
    let max_count: number = 999;
    const loader = useRef(null);
    const [page, setPage] = useState(-count);

    const { member } = props;

    const moveMaterialSheet = (index: number) => {
        if (index >= 0) {
            history.push({
                pathname:
                    '/MaterialSaleList/' + material[index].materialOrderNum,
                state: {
                    // location state
                    sale: material[index],
                },
            });
        }
    };

    const moveMaterialOrder = () => {
        history.push({
            pathname: '/OrderList',
        });
    };

    const handleObserver = useCallback((entries: any) => {
        const target = entries[0];
        if (target.isIntersecting) {
            setPage((prevState) => {
                if (prevState + count > max_count) {
                    return prevState;
                }
                return prevState + count;
            });
        }
    }, []);

    const handleProcessing = () => {
        return;
    };

    async function getMaxMaterialCount(): Promise<number> {
        let url = new URL(
            basic.server + v_member.member + v_member.material_count
        );
        const response = await axios({
            method: 'GET',
            withCredentials: true,
            url: url.toString(),
        });
        const data = await response.data;
        const count: number = data.count.count;
        return count;
    }

    const getMaterialSaleAppList = (position: number, count: number) => {
        let url = new URL(
            basic.server + v_member.member + v_member.material_sale_app_list
        );
        let params = {
            classCode: member.classCode,
            companyNum: member.companyNum,
            position: position.toString(),
            count: count.toString(),
            email: member.id,
            classVersion: member.classVersion,
        };
        url.search = new URLSearchParams(params).toString();

        axios({
            method: 'GET',
            withCredentials: true,
            url: url.toString(),
        })
            .then((res) => res.data)
            .then((data: any) => {
                console.log(data.materials);
                console.log(material.length);
                if (data.code === Values.SUCCESS_CODE) {
                    if (material.length === 0 && data.materials.length === 0) {
                        //enqueueSnackbar(ToastStr.MATERIAL_ORDER_LIST_EMPTY_STR, { variant: "success", autoHideDuration: SNACKBAR_TIME, translate: "no" })
                    } else if (data.materials === null) {
                        enqueueSnackbar(
                            ToastStr.MATERIAL_ORDER_LIST_EMPTY_STR,
                            {
                                variant: 'warning',
                                autoHideDuration: SNACKBAR_TIME,
                                translate: 'no',
                            }
                        );
                    } else {
                        if (material.length === 0) {
                            setMaterial(data.materials);
                        } else {
                            setMaterial((prevState) =>
                                prevState.concat(data.materials)
                            );
                        }
                    }
                } else if (data.code === Values.FAIL_CODE) {
                    enqueueSnackbar(ToastStr.MATERIAL_ORDER_LIST_FAIL_STR, {
                        variant: 'warning',
                        autoHideDuration: SNACKBAR_TIME,
                        translate: 'no',
                    });
                } else if (data.code === Values.EXCEPTION_CODE) {
                    enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, {
                        variant: 'error',
                        autoHideDuration: SNACKBAR_TIME,
                        translate: 'no',
                    });
                } else {
                    enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, {
                        variant: 'error',
                        autoHideDuration: SNACKBAR_TIME,
                        translate: 'no',
                    });
                }
            });
    };

    useEffect(() => {
        const option = {
            root: null,
            rootMargin: '20px',
            threshold: 0,
        };
        const observer = new IntersectionObserver(handleObserver, option);
        if (loader.current) observer.observe(loader.current!);
    }, [handleObserver]);

    useEffect(() => {
        if (page >= 0) {
            console.log(page);
            getMaterialSaleAppList(page, count);
            const tick = setInterval(() => {
                getMaterialSaleAppList(page, count);
            }, 1000 * 5);
            return () => clearTimeout(tick);
        }
    }, [page]);

    return (
        <div className="content">
            <div className={classes.wrapper}>
                <TitleBar
                    history={history}
                    title="재료판매"
                    titleIcon="order"
                />

                <Box display="grid" justifyContent="center" alignItems="center">
                    <div className={classes.buttonWrapper}>
                        <Button
                            className={classes.button}
                            onClick={moveMaterialOrder}
                        >
                            재료 영수증
                        </Button>
                    </div>
                    <div className={classes.titleWrapper}>
                        <Typography className={classes.title}>
                            창을 누르시면 더 자세한 재료주문내역을 알 수
                            있습니다.
                        </Typography>
                    </div>
                    <List className={classes.list}>
                        {material.length != 0 ? (
                            material.map((item: any, index) => {
                                return (
                                    <ListItem
                                        className={
                                            item.materialOrderStatus ==
                                            'processing'
                                                ? clsx(
                                                      classes.materialItem,
                                                      classes.itemProcessing
                                                  )
                                                : classes.materialItem
                                        }
                                        alignItems="center"
                                    >
                                        <MaterialItem
                                            {...item}
                                            handleClick={(e: any) => {
                                                item.materialOrderStatus ==
                                                'processing'
                                                    ? handleProcessing()
                                                    : moveMaterialSheet(index);
                                            }}
                                        />
                                    </ListItem>
                                );
                            })
                        ) : (
                            <div className={classes.empty}>
                                <div>
                                    <img src="/images/title/order.webp" />
                                    <Typography variant="h1">
                                        재료 주문 내역이 없습니다.
                                    </Typography>
                                </div>
                            </div>
                        )}
                        <div ref={loader} />
                    </List>
                </Box>
            </div>
        </div>
    );
};

const MaterialItem: React.FC<any> = (props) => {
    const classes = useStyles();

    return (
        // new version
        <Grid
            container
            justify={'center'}
            alignContent="center"
            onClick={props.handleClick}
            translate="no"
        >
            <Grid xs={2} className={classes.materialImage}>
                <img
                    src={
                        basic.server +
                        '/displayImage?fileName=' +
                        props.materialImage
                    }
                />
            </Grid>
            <Grid xs={8} style={{ margin: 'auto', paddingLeft: '1vw' }}>
                <Grid container direction="column">
                    <Grid id="materialName">
                        <Typography
                            display="inline"
                            className={classes.bottonTitle}
                        >
                            {`${props.materialName}`}
                        </Typography>
                        <Typography
                            display="inline"
                            variant="h3"
                            className={classes.bottonTitle}
                        >
                            {props.materialCount > 1 ? ` 외 ` : ` `}
                        </Typography>
                        {/* <Typography display='inline' variant='h3' style={{ color: `${COLORS.WATER_BLUE}`, fontWeight: 'bold' }}>{props.materialCount > 1 ? props.materialCount - 1 : ``}</Typography> */}
                        <Typography
                            display="inline"
                            variant="h3"
                            className={classes.bottonTitle}
                        >
                            {props.materialCount > 1 ? `여러 건` : ``}
                        </Typography>
                    </Grid>
                    <Grid id="orderStatus">
                        <Typography
                            variant="h1"
                            className={classes.materialCompanyName}
                        >
                            {props.materialOrderStatus != 'processing'
                                ? props.companyName
                                : `${props.companyName} / ${props.workingMemberName}`}
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
            <Grid xs={2} className={classes.numberWrapper}>
                <Typography className={classes.numberText}>
                    {props.materialOrderDate != null &&
                        props.materialOrderDate.length >= 19 &&
                        props.materialOrderDate
                            .substring(5, 10)
                            .replace('-', '/')}
                </Typography>
                <Typography className={classes.numberText}>
                    {props.materialOrderDate != null &&
                        props.materialOrderDate.length >= 19 &&
                        props.materialOrderDate.substring(10, 16)}
                </Typography>
            </Grid>
        </Grid>
    );
};
export default MaterialSale;
